export default "__VITE_ASSET__DHe046OB__"